export const RQ_GET_BRAND_GROUP_LIST_API = {
  url: 'secondarysalesmaster/detail/<%= locationId %>/<%= yyyyMm %>',
  method: 'GET',
  auth: true,
};

export const RQ_SAVE_BRAND_ALLOCATION_API = {
  url: 'secondarybrandwisehqlevelplanning/savePlan',
  method: 'POST',
  auth: true,
};

export const RQ_GET_BRAND_ALLOCATION_FOR_MANAGER_API = {
  url: 'secondarybrandwisehqlevelplanningmaster/getAllocationList/<%= sapCode %>/<%= employeeId %>/<%= yyyyMm %>',
  method: 'GET',
  auth: true,
};

export const RQ_SAVE_ALLOCATION_CHANGES_API = {
  url: 'secondarybrandwisehqlevelplanningmaster/saveAllocationChanges',
  method: 'PUT',
  auth: true,
};

export const RQ_APPROVE_REJECT_API = {
  url: 'secondarybrandwisehqlevelplanningmaster/approveReject',
  method: 'PUT',
  auth: true,
};

export const RQ_ESCALATE_ALLOCATION_API = {
  url: 'secondarybrandwisehqlevelplanningmaster/escalateAllocation/<%= masterId %>',
  method: 'PUT',
  auth: true,
};

export const RQ_GET_ESCALATION_LIST = {
  url: 'secondarybrandwisehqlevelplanningmaster/getEscalationList/<%= employeeId %>/<%= yyyyMm %>',
  method: 'GET',
  auth: true,
};

export const RQ_RESUBMIT_ALLOCATION = {
  url: 'secondarybrandwisehqlevelplanningmaster/resubmit',
  method: 'PUT',
  auth: true,
};

export const RQ_DR_LEVEL_PLANNING_FETCH_API = {
  url: 'drlevelsecondarysalesmaster/dr-level-detail/<%= locationId %>/<%= yyyyMm %>',
  method: 'GET',
  auth: true,
};

export const RQ_SAVE_DR_LEVEL_PLANNING_API = {
  url: 'drlevelsecondarysalesmaster/savePlan',
  method: 'POST',
  auth: true,
};

export const RQ_SUBMIT_DR_LEVEL_PLANNING_API = {
  url: 'drlevelsecondarysalesmaster/submitPlan',
  method: 'POST',
  auth: true,
};

export const RQ_FETCH_DR_ALLOCATION_APPROVAL_LIST_API = {
  url: 'drlevelsecondarysalesplanning/getApprovalList/<%= approverId %>/<%= yyyyMm %>',
  method: 'GET',
  auth: true,
};

export const RQ_FETCH_DR_ALLOCATION_APPROVAL_API = {
  url : 'drlevelsecondarysalesplanning/getDrSecondarySales/<%= locationId %>/<%= yyyyMm %>/<%= approverId %>',
  method: 'GET',
  auth: true,
};

export const RQ_DR_ALLOCATION_APPROVE_REJECT_API = {
  url: 'drlevelsecondarysalesmaster/approveRejectSecondaryPlan',
  method: 'PUT',
  auth: true,
};
